module.exports = __webpack_public_path__ + "img/consignacao-select.b9cb8555.svg";